import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EventEmitter } from 'stream';
const USER_API = environment.apiUrl;

@Injectable({
    providedIn: 'root'
})
export class ScheduleService {
    findPartnerStartDate = new BehaviorSubject<string>('');
    constructor(private http: HttpClient) { }

    getScheduleList(query): Observable<any> {
        return this.http.get(USER_API + "userschedule" + query);
    }

    getScheduleDetails(id): Observable<any> {
        return this.http.get(USER_API + "userschedule/" + id);
    }

    updateSchedule(id, userscheduledata): Observable<any> {
        return this.http.put(USER_API + 'userschedule/' + id, userscheduledata);
    }
    updateUserSchedule(id, userscheduledata): Observable<any> {
        return this.http.put(USER_API + 'userschedule/update/' + id, userscheduledata);
    }

    addSchedule(userscheduleData): Observable<any> {
        return this.http.post(USER_API + 'userschedule', userscheduleData);
    }
    // getSchedule(): Observable<any> {
    //   return this.http.get(USER_API+"userschedule/");
    // }
    getSchedule(id): Observable<any> {
        return this.http.get(USER_API + "userschedule/" + id);
    }

    updatestatus(id,data): Observable<any>{
        return this.http.put(USER_API + 'userschedule/'+id, data);
    }
    cashReturn(id,data): Observable<any>{
        return this.http.put(USER_API + 'userschedule/cash-return/'+id, data);
    }

    viewScheduleStartDate(startDate:string){
        this.findPartnerStartDate.next(startDate);
    }

    getPartnerPrivateConversation(userId: string, opponentUserId: string): Observable<any> {
        return this.http.get(USER_API + `chat/conversations/private/by-users?userId=${userId}&opponentUserId=${opponentUserId}`);
    }

    getPartnerChatHistory(conversationId: string, query: string): Observable<any> {
        return this.http.get(USER_API + 'chat/conversations/' + conversationId + '/messages/admin?' + query);
    }
}
